const renderArray = (
  array,
  callbackFn,
  spacer = null,
  emptyArrayItem = null,
  nullArrayItem = null,
) => {
  if (array) {
    const numberOfItems = array.length;

    if (numberOfItems === 0) {
      return emptyArrayItem;
    }

    if (numberOfItems > 0) {
      return callbackFn(callback =>
        array.reduce((acc, item, index) => {
          acc.push(callback(item, index));

          if (spacer && index < numberOfItems - 1) {
            acc.push(spacer);
          }

          return acc;
        }, []),
      );
    }
  }

  return nullArrayItem;
};

export default renderArray;
